import React from 'react'
import constants from 'constants/constants'
import { S } from './Resources'

const Contact = () => (
    <S.Wrapper>
        <iframe
            width="100%"
            height="100%"
            title="contact"
            src={`${constants.contextualHelpBaseUrl}lite/contact/`}
            frameBorder="0"
        />
    </S.Wrapper>
)

export default Contact
